export default "__VITE_ASSET__ab55e52b__"